import { InputChangeEvent, useIntl } from 'platform-components';
import { INPUT_SIZES } from 'platform-components/constants';
import React from 'react';

// @ts-ignore
import Input from 'common.components/form-view/__input/form-view__input.jsx';

export enum CERTIFICATES_PARAMS_MODAL_DATA_TYPE {
    FULL_NAME = 'fullName',
    LOCALITY = 'locality',
    SCHOOL = 'school',
}

interface Props {
    errorMessage: string | null;
    onBlur: () => void;
    onChangeValue: (event: InputChangeEvent) => void;
    type: CERTIFICATES_PARAMS_MODAL_DATA_TYPE;
    value: string;
}

const CertificatesParamsModalFormField = (props: Props) => {
    const { errorMessage, onChangeValue, onBlur, type, value } = props;
    const intl = useIntl();

    return (
        <div className="certificates-params-modal__form-field">
            <Input
                errorMessage={errorMessage}
                labelId={`certificatesParamsModal.${type}.label`}
                mix="certificates-params-modal__form-field-input"
                onBlur={onBlur}
                onChange={onChangeValue}
                onFocus={onChangeValue}
                placeholder={intl.formatMessage({ id: `certificatesParamsModal.${type}.placeholder` })}
                size={INPUT_SIZES.L}
                theme={Input.THEME.OUTLINED}
                valid={errorMessage ? 'no' : 'uncertain'}
                value={value}
            />
        </div>
    );
};

export default CertificatesParamsModalFormField;
